import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';

import { Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';



@Component({
  selector: 'app-address-create',
  templateUrl: './address-create.component.html',
  styleUrls: ['./address-create.component.css']
})
export class AddressCreateComponent implements OnInit {
  id: string;
  private usersCollection: AngularFirestoreCollection<Users>;
address: Iaddress;
  constructor(
    private db: AngularFirestore,
    private route: ActivatedRoute) {
      this.usersCollection = db.collection<Users>('users');
    }

  ngOnInit() {
    this.address = {


      administrative_area_level_1: null,
      administrative_area_level_3: null,
      street_number: null,
      country: null,
       route: null,
        postal_code: null,
         latitude: null,
         longitude: null,
          administrative_area_level_2: null
    };
    this.id = this.route.snapshot.params.id;
    const a = this.usersCollection.doc(this.id).collection('address').doc();
  }

}
